import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableEditVodOptimizationSettings from './tableEditVodOptimizationSettings';

export default {
  title: 'Optimization Settings',
  attributeName: 'optimizationSettings',
  fields: [
    {
      attributeName: 'optimizationSettings',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableEditVodOptimizationSettings,
    },
  ],
};
